var map = {
	"./Backpack.webp": 300,
	"./Bike.png": 4789,
	"./Drafter.png": 6612,
	"./Furniture.png": 594,
	"./Headphones.png": 7087,
	"./Laptop.webp": 2878,
	"./Mobile.webp": 7492,
	"./Myresume.pdf": 5909,
	"./Powerbank.png": 6001,
	"./Quantum.jpg": 3911,
	"./RAM&SSD.webp": 990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6060;